export type Customer = {
  firstName: string;
  lastName: string;
  gender: string;
  dateOfBirth: null | string;
  salutation: string;
  email: string;
  phone: string;
  id?: string;
  isVerified: boolean;
  createdAt: string;
  updatedAt: string;
};

export enum UserStatus {
  GUEST = 'GUEST',
  UNREGISTERED = 'UNREGISTERED',
  REGISTERED = 'REGISTERED',
  VERIFIED = 'VERIFIED',
}

export enum Salutation {
  MR = 'Mr.',
  MS = 'Ms.',
  NONE = 'None',
}
